import { Add, Remove } from "@mui/icons-material";
import { Box, Collapse, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
export const FaqElement = ({ children, startOpen = false, question, questionElement = "h3", }) => {
    const theme = useTheme();
    const [open, setOpen] = React.useState(startOpen);
    const toggle = () => setOpen((curr) => !curr);
    const size = { xs: theme.spacing(3), md: theme.spacing(5) };
    const spacing = 4;
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { alignItems: "baseline", direction: "row", spacing: spacing, sx: { "&:hover": { cursor: "pointer" } }, onClick: toggle },
            React.createElement(Box, { sx: {
                    minWidth: size,
                    width: size,
                    height: size,
                    position: "relative",
                    bottom: { xs: "-11px", md: "-6px" },
                } }, open ? React.createElement(Remove, null) : React.createElement(Add, null)),
            React.createElement(Typography, { component: questionElement, variant: "h3", sx: { pt: 0, pb: 0 } }, question)),
        React.createElement(Stack, { alignItems: "center", direction: "row", spacing: spacing },
            React.createElement(Box, { sx: { minWidth: size, width: size, height: size } }),
            React.createElement(Box, null,
                React.createElement(Collapse, { in: open, sx: { pt: 1 } }, typeof children === "string" ? (React.createElement(Typography, { variant: "body1", paragraph: true }, children)) : (children))))));
};
//# sourceMappingURL=faq-element.js.map